<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjkd/mtksj">媒体看盛京</router-link>
    </div>
    <div class="container-width">
      <LIST :listData="list" :articlePath="articlePath"></LIST>
      <Pagination
        :pageCount="totalPages"
        :total="total"
        @togglePage="togglePage($event)"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import service from "../../../service/index";
import BANNER from "../../../components/banner/sjkd";
export default {
  name: "MTKSJ",
  data() {
    return {
      navigationData: [
        {
          name: "媒体看盛京",
          path: "/sjkd/mtksj",
        },
      ],
      currentPath: "/sjkd/mtksj",
      articlePath: "/sjkd/mtksj/article",
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getwzMediaViewsjList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },
    goArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/sjkd/mtksj/article`,
          query: {
            id: e.id,
          },
        });
      }
    },
    togglePage(index) {
      this.pageIndex = index;
      this.init();
    },
  },
  mounted() {},
  watch: {},
};
</script>




<style>
</style>
